var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07764 2.2022C8.42034 1.38396 9.57966 1.38396 9.92236 2.2022L11.1565 5.14868C11.3006 5.49291 11.6245 5.72821 11.9964 5.75896L15.1801 6.02214C16.0642 6.09523 16.4224 7.1978 15.7501 7.77659L13.3292 9.86079C13.0464 10.1043 12.9227 10.485 13.0084 10.8482L13.7419 13.9574C13.9455 14.8208 13.0076 15.5022 12.2494 15.0417L9.51914 13.3833C9.20016 13.1896 8.79984 13.1896 8.48087 13.3833L5.75056 15.0417C4.99236 15.5022 4.05445 14.8208 4.25815 13.9574L4.99164 10.8482C5.07733 10.485 4.95362 10.1043 4.67079 9.86079L2.24988 7.77659C1.57759 7.1978 1.93584 6.09523 2.81993 6.02214L6.00356 5.75896C6.3755 5.72821 6.69936 5.49291 6.84354 5.14868L8.07764 2.2022Z",
    stroke: "#D4D9E6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;